import React, { useState, useEffect, useCallback } from "react";
import {
    Table, TableBody, TableCell, TableHead, TableRow, Card, Box, Button,
    TextField, MenuItem, Select, FormControl, InputLabel, Grid, Paper, TableContainer,
       
} from "@material-ui/core";
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import CheckIcon from "@material-ui/icons/CheckCircle";
import StarIcon from "@material-ui/icons/Star";
import WarningIcon from '@material-ui/icons/Warning';

// import DevelopingIcon from "@material-ui/icons/TipsAndUpdates";
import AttentionIcon from "@material-ui/icons/ReportProblem";
import ErrorIcon from '@material-ui/icons/Error';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import SubActivityService from "./Locality/Service/subActivityService";
import AddClassService from "./Locality/Service/addClassService";
import PageTitle from "../../components/PageTitle/PageTitle";
import ActivityService from "./Locality/Service/activityService";
import SuperActivityService from "./Locality/Service/superActivityService"
import StudentService from "./Locality/Service/studentService"
const statuses = ["P", "WA", "WI", "M"]; // Presented, Work with Assistance, etc.
const statusLabels = {
    P: "Presented",
    WA: "Works with Assistance",
    WI: "Works Independently",
    M: "Mastered",
};

const StyledTableCell = withStyles((theme) => ({
    head: {
        backgroundColor: "#0f3b62ad",
        color: theme.palette.common.white,
    },
    body: {
        fontSize: 14,
    },
}))(TableCell);
const useStyles = makeStyles((theme) => ({
    container: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    textField: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
        width: 200,
    },
}));

export default function ActivityAnalysisAdmin() {
    const classes = useStyles();
    const [allSuperActivities, setAllSuperActivities] = useState([]);

    const [activityList, setActivityList] = useState([]);
    const [studentsList, setstudentsList] = useState([]);
    var [classId, setClassId] = useState("");
    const [addSuperActivityList, setAddSuperActivityList] = useState([]);
    const [studentList, setStudentList] = useState([]);
    var [isLoading, setIsLoading] = useState(false);
    const [addClassList, setAddClassList] = useState([]);
    var [studentId, setStudentId] = useState("");
    const [selectedKey, setSelectedKey] = useState("");
    const keyOptions = [
        { label: 'Strong area', value: 'M,WI' },
        { label: 'Developing area', value: 'WA' },
        { label: 'Needs attention', value: 'P' },
    ];
    const [activeTab, setActiveTab] = useState('');
    
    useEffect(() => {
        getAddClassList();



        return () => {
            setAddSuperActivityList([]);
            setActivityList([]);
        }
    }, []);
    const colorMap = {
        "P": "#5C9882",
        "WI": "#E6B163",
        "WA": "#A75C9C",
        "M": '#147ad482'
    };
    
const transformActivityData = (data) => {
  // Group by subActivityName
  const grouped = {};
  data.forEach(item => {
    if (!grouped[item.subActivityName]) {
      grouped[item.subActivityName] = {
        activityName: item.subActivityName,
        M: 0,
        WI: 0,
        WA: 0,
        P: 0,
      };
    }
    if (["M", "WI", "WA", "P"].includes(item.key)) {
      grouped[item.subActivityName][item.key] = item.count;
    }
  });
  return Object.values(grouped);
};

   const fetchActivityAnalysis = useCallback(() => {
  if (!classId) {
    setActivityList([]);
    return;
  }

  setIsLoading(true);
  const userDetails = JSON.parse(localStorage.getItem("userDetail"));
  const keys = {
    schooleId: userDetails.schooleId,
    classId,
  };

  ActivityService.getActivityAnalysisByClass(keys)
    .then((result) => {
      setActivityList(transformActivityData(result));
    })
    .catch((err) => {
      console.error(err);
      setActivityList([]);
    })
    .finally(() => {
      setIsLoading(false);
    });
}, [classId]);

  useEffect(() => {
    fetchActivityAnalysis();
  }, [fetchActivityAnalysis]);

    const getAddClassList = (event) => {
        const userDetails = JSON.parse(localStorage.getItem("userDetail"));
        AddClassService.getAllAddClass(userDetails.schooleId).then((res) => {
            if (userDetails.role === "TEACHER") {
                res = res.filter(res => res._id === userDetails.classId);
            }
            setAddClassList(res);
            if (userDetails.role === "TEACHER" && userDetails.classId) {
                const selectedClassId = userDetails.classId;
                setClassId(selectedClassId);
                getStudentList({ target: { value: selectedClassId } });
                getSuperActivityList(selectedClassId)
            }
            else if (res.length > 0) {
                setClassId(res[0]._id); // No default selection
                getSuperActivityList(res[0]._id)
                getStudentList({ target: { value: res[0]._id } })
            }
        }).catch((err) => {
            // setError(err.message);
        });
    }

    const getSuperActivityList = async (classId) => {
        const userDetails = JSON.parse(localStorage.getItem("userDetail"));
        try {
            const res = await SuperActivityService.getAllSuperActivityById(userDetails.schooleId, { classId: classId });
            setAllSuperActivities(res); // Save all to filter later

            // Initial filter (if classId already set)
            if (classId) {
                const filtered = res.filter(item => item.classId?._id === classId);
                setAddSuperActivityList(filtered);
                if (filtered.length > 0) {
                    setActiveTab(filtered[0]._id);
                } else {
                    setActiveTab("");
                }
            }
        } catch (err) {
            console.error(err);
        }
    };
   

    const getStudentList = (event) => {
        const selectedClassId = event?.target?.value || classId;
        const userDetails = JSON.parse(localStorage.getItem("userDetail"));

        StudentService.getAllStudentById(userDetails.schooleId)
            .then((res) => {
                const filteredStudents = res.filter(
                    (student) => student.classId && student.classId._id === selectedClassId
                );
                const studentDetails = filteredStudents.map((student) => ({
                    _id: student._id,
                    studentName: `${student.firstName} ${student.lastName}`,
                    status: true,
                }));
                setStudentList(studentDetails);
            })
            .catch((err) => {
                console.error("Error fetching students:", err);
            });
    };

    const handleTabClick = (superActivityId) => {
        setActiveTab(superActivityId);
    };
    const getStudentReportList = () => {
        const userDetails = JSON.parse(localStorage.getItem("userDetail"));

        if (studentId == '') {
            alert("Please Select Student");
            return;
        }
        const getstudentId = { "studentId": studentId, };

        SubActivityService.getStudentReport(getstudentId).then((res) => {
            // const blob = new Blob(res.pdfBuffer);
            const buffer = Buffer.from(res.pdfBuffer);
            const blob = new Blob([buffer]);
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            document.body.appendChild(a);
            a.style = "display: none";
            a.href = url;
            a.download = "studentreport.pdf";
            a.click();
            window.URL.revokeObjectURL(url);
            // const blob = new Blob([res.pdfBuffer]);
            // saveAs(blob, 'filename.pdf');
            // const file = new File(res.pdfBuffer, 'filename.txt', { type: 'text/plain' });
            // setStudentReportList(res);
        }).catch((err) => {
            alert(err.response.data.message)
        });
    }
    return (

        <Paper style={{ padding: 20 }}>
            <PageTitle title="Activity Wise Analysis" />
            <Card sx={{ maxWidth: 345 }}>
                <Box style={{ margin: 15, }} >


                    <Grid container spacing={2} columns={12} style={{ margin: 10, }}  >
                        <Grid item xs={12} sm={6} md={6}  >
                            <FormControl className={classes.formControl} style={{ width: 420 }}
                            >
                                <InputLabel id="demo-simple-select-label">Select Class</InputLabel>
                                <Select
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    name="classId"
                                    label="selectClass"
                                    onChange={e => {
                                        const selectedClassId = e.target.value;
                                        setClassId(selectedClassId);
                                        getStudentList(e);
                                        getSuperActivityList(selectedClassId);
                                    }}
                                    value={classId}
                                >
                                    <MenuItem value="">
                                        <em>None</em>
                                    </MenuItem>

                                    {addClassList.map(({ _id, className }) => (
                                        <MenuItem key={_id} value={_id}>{className}

                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>

                        </Grid>
                    </Grid>



                </Box>
            </Card>
                                                        <TableContainer component={Paper} style={{ maxHeight: 500 }}>
    
<Table  stickyHeader style={{ marginTop: 20, width: "100%" }}>  
  <TableHead>
    <TableRow>
      <StyledTableCell>Activity Name</StyledTableCell>
      <StyledTableCell>Mastered</StyledTableCell>
      <StyledTableCell>WI</StyledTableCell>
      <StyledTableCell>WA</StyledTableCell>
      <StyledTableCell>Presented</StyledTableCell>
    </TableRow>
  </TableHead>
  <TableBody>
    {activityList.length > 0 ? (
      activityList.map((activity, index) => (
        <TableRow key={index}>
          <StyledTableCell>{activity.activityName}</StyledTableCell>
          <StyledTableCell>{activity.M}</StyledTableCell>
          <StyledTableCell>{activity.WI}</StyledTableCell>
          <StyledTableCell>{activity.WA}</StyledTableCell>
          <StyledTableCell>{activity.P}</StyledTableCell>
        </TableRow>
      ))
    ) : (
      <TableRow>
        <StyledTableCell colSpan={5} align="center">
          No data available
        </StyledTableCell>
      </TableRow>
    )}
  </TableBody>
</Table>
</TableContainer >





        </Paper>
        
        
    );
}





































